import { Toast } from './Toast';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * TODO:
 * - replace div with Flex once it accepts zIndex and transform properties
 */
export const Toaster = ({
  toasts,
  autoClose
}) => {
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "foundations-components-toaster",
    style: {
      display: 'flex',
      flexDirection: 'column-reverse',
      rowGap: '20px',
      zIndex: 1000,
      position: 'fixed',
      top: '0%',
      left: '50%',
      transform: 'translateX(-175px)'
    },
    children: toasts.map(toast => /*#__PURE__*/_jsx(Toast, Object.assign({}, toast, {
      autoClose: autoClose
    }), toast.id))
  });
};